import clsx from 'clsx';
import React from 'react';

type Props = { className?: string };

export default function AuthBanner({
  className = '', // default className
}: Props) {
  const wrapperClass = clsx(
    className,
    'hidden lg:block sticky top-0 left-auto h-full overflow-hidden'
  );

  return (
    <div className={wrapperClass}>
      <div className="w-full h-full relative bg-primary rounded-md overflow-hidden">
        <img
          src="/images/sidebar-image.jpg"
          alt="Health app"
          className="min-w-full min-h-full opacity-50 object-cover"
        />

        <div className="absolute top-0 left-0 w-full h-full p-6 flex flex-col justify-between">
          <div className="flex justify-end">
            <a href="/">
              <img
                src="/images/swiftmedix.svg"
                alt="Swiftmedix logo"
                className="h-6"
              />
            </a>
          </div>

          <div className="flex flex-col items-center justify-center gap-3 bg-[rgba(18,55,99,0.75)] p-8 rounded border border-[rgba(255,255,255,0.11)] text-white text-center">
            <h5 className="font-parkinsans font-semibold">
              Living Healthy made Easy
            </h5>
            <small>
              Get access to your favourite shops and pharmacy anytime, anywhere
            </small>
            <svg
              width="35"
              height="6"
              viewBox="0 0 35 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="17.223"
                height="5.74101"
                rx="2.8705"
                fill="#00C59E"
              />
              <rect
                x="20.0938"
                width="5.74101"
                height="5.74101"
                rx="2.8705"
                fill="white"
              />
              <rect
                x="28.7051"
                width="5.74101"
                height="5.74101"
                rx="2.8705"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
